export default {
  loadCredentials() {
    return {
      deviceId: this.getDeviceId(),
      projectId: localStorage.getItem("projectId"),
      code: localStorage.getItem("code")
    }
  },
  generateCode() {
    const codeLenght = 6
    return (Math.random().toString(36) + "0123456789ABCDEFG")
      .slice(2, codeLenght + 2)
      .toUpperCase()
  },
  saveCode(code) {
    localStorage.setItem("code", code)
  },
  saveProjectId(projectId) {
    localStorage.setItem("projectId", projectId)
  }
}
